if(!document.querySelector(".atlas-depth")){

(function(){
  var a=document.createElement('a');
  a.className='atlas-dock';
  a.href=document.getElementById('atlas')?'#atlas':(window.__ATLAS_URL__||'nonduality-atlas.html');
  a.innerHTML='The atlas \u2192';
  document.body.appendChild(a);
  var atlas=document.getElementById('atlas');
  function tick(){
    var past=window.scrollY>700;
    var inAtlas=false;
    if(atlas){var r=atlas.getBoundingClientRect(); inAtlas=r.top<window.innerHeight*0.6 && r.bottom>0;}
    a.classList.toggle('on', past && !inAtlas);
  }
  window.addEventListener('scroll',tick,{passive:true});
  window.addEventListener('resize',tick); tick();
})();

}

function lpNavSearch(e){
  e.preventDefault();
  var q=((document.getElementById('lpNavQ')||{}).value||'').trim();
  var box=document.getElementById('search');
  if(box){
    /* the atlas may be collapsed on a content page — open it before searching in it */
    if(typeof revealAtlas==='function'){
      var ex=document.getElementById('atlasExplorer');
      if(ex && !ex.classList.contains('open')) revealAtlas(false);
    }
    box.value=q;
    box.dispatchEvent(new Event('input',{bubbles:true}));
    var anchor=document.getElementById('level-1')||document.getElementById('atlasExplorer')
              ||document.getElementById('atlas');
    if(anchor) anchor.scrollIntoView({behavior:'smooth',block:'start'});
    setTimeout(function(){ try{ box.focus({preventScroll:true}); }catch(err){ box.focus(); } },420);
  } else {
    /* no atlas on this page: hand the search to the Atlas page */
    location.href=(window.__ATLAS_URL__||'nonduality-atlas.html')+'?q='+encodeURIComponent(q);
  }
  return false;
}
